export const DoubleDownArrow = () => {
  return (
    <svg
      className="stroke-[--synapse-secondary] stroke-2 fill-none inline group-open:-scale-y-100"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 5.5L10 9.5L14 5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 11.5L10 15.5L14 11.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
